export default "__VITE_ASSET__yb$RA3fXWiW5Ks9qJ6pVEg__";